export type UISettings = {
  Image: string;
  Description: string;
  [key: string]: any;
}

export type OrderType = 'Default' | 'Delivery' | 'Pickup' | 'DineIn';
export const OrderTypes = ['Delivery', 'Pickup', 'DineIn'] as OrderType[];
export type OrderSource = 'Default' | 'POS' | 'Online';
export const OrderSources = ['POS', 'Online'] as OrderSource[];
export type OrderStatus = 'New' | 'Pending' | 'Accepted' | 'Preparing' | 'Ready' | 'Delivering' | 'Delivered' | 'Canceled' | 'Rejected';
export const OrderStatuses = ['New', 'Pending', 'Accepted', 'Preparing', 'Ready', 'Delivering', 'Delivered', 'Canceled', 'Rejected', 'Failed'] as OrderStatus[];

export type orderStage = { key: string, label: string, statuses: string[], total?: number, limit?: number, updated?: boolean };
export const orderStages = [
  { key: 'all', label: 'All Orders', statuses: [] },
  { key: 'new', label: 'New Orders', statuses: ['Pending'] },
  { key: 'draft', label: 'NEW', statuses: ['New'] },
  { key: 'inprogress', label: 'In progress', statuses: ['Accepted', 'Preparing', 'Ready', 'Delivering'] },
  { key: 'completed', label: 'Completed', statuses: ['Delivered'], limit: 10 },
  { key: 'canceled', label: 'Canceled', statuses: ['Canceled', 'Rejected'], limit: 10 },
] as orderStage[];

export class Constants {
  static WeekDays = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  static OrderTypes = ['Default', 'Delivery', 'Pickup', 'DineIn'];
  static OrderSources = ['Default', 'POS', 'Online'];
  static OrderStatuses = ['New', 'Pending', 'Accepted', 'Preparing', 'Ready', 'Delivering', 'Delivered', 'Canceled', 'Rejected', 'Failed'];
  static MenuItemOptionTypes = ['Custom', 'Size', 'Crust', 'Dip', 'Dressing', 'Topping', 'Instruction'];
  static DiscountTypes = ['FixPrice', 'DiscountAmount', 'DiscountPercentage'];
  static BusinessPermissions = ['Order', 'Feedback', 'Availability', 'Menu', 'Business', 'Report', 'Payments', 'Reservation'];
  static Permissions = ['manage-business', 'manage-users', 'manage-payments', 'manage-menu', 'manage-order', 'manage-promotions', 'view-dashboard-statistics'];
}

export type Location = {
  Title?: string;
  Country?: string;
  County?: string;
  City?: string;
  Highway?: string;
  Postcode?: string;
  DoorNumber?: string;
  AddressLines?: string[];
  Phone?: string;
  Latitude?: number;
  Longitude?: number;
};

export class PaymentData {
  Url: string;
  Data: { [key: string]: string }
}

export type PaymentSearchCriteria =
  {
    Query?: string;
    UserId?: string;
    BusinessId?: string;
    Statuses?: PaymentStatus[];
    ExcludedStatuses?: PaymentStatus[];
    FromRegisterTime?: Date;
    ToRegisterTime?: Date;
  }

export type PaymentStatus = "Unpaid" | "Success" | "Declined" | "Failed" | "Waiting" | "Mismatch" | "Refund" | "RefundToBalance";

export type SearchResults<T> = {
  Total: number;
  List: T[];
}


export type PublicProfile = {
  Name: string;
  ImageUrl: string;
}

export type Feedback = {
  Id?: string;
  BusinessId?: string;
  UserId?: string;
  ClientId?: string;
  Status?: FeedbackStatus;
  ItemType?: FeedbackItemType;
  Rating?: number;
  IsDeleted?: boolean;
  RegisterTime?: Date;
  PublishTime?: Date;
  UserProfile?: PublicProfile;
  Items?: FeedbackItem[];
}

export type FeedbackStatus = "Draft" | "Pending" | "Approved" | "Rejected";

export type FeedbackSearchCriteria = {
  BusinessId?: string;
  UserId?: string;
  ClientId?: string;
  ItemId?: string;
  Statuses?: FeedbackStatus[];
  ExcludedStatuses?: FeedbackStatus[];
  ItemType?: FeedbackItemType;
  IsDeleted?: boolean;
  From?: number;
  Size?: number;
}

export type FeedbackItem = {
  Type?: FeedbackItemType;
  ItemId?: string;
  ItemOptions?: string[];
  Rating?: number;
  Attachments?: string[];
  Comment?: string;
  PositiveTags?: string[];
  NegativeTags?: string[];
  Reply?: string;
}

export type FeedbackItemType = "Business" | "Menu" | "MenuItem" | "Order";

export type ReservationStatus = "Pending" | "Confirmed" | "Declined" | "Cancelled" | "Completed" | "NoShow";

export type Reservation = {
  Id?: string;
  BusinessId?: string;
  UserId?: string;
  ClientId?: string;
  Status?: ReservationStatus;
  ReservationTime?: string | Date;
  PartySize?: number;
  Name?: string;
  Phone?: string;
  Email?: string;
  Notes?: string;
  IsDeleted?: boolean;
  RegisterTime?: Date;
  ReviewUserId?: string;
  ReviewTime?: Date;
  BusinessReply?: string;
}

export type ReservationSearchCriteria = {
  BusinessId?: string;
  UserId?: string;
  ClientId?: string;
  Statuses?: ReservationStatus[];
  FromDate?: string | Date;
  ToDate?: string | Date;
  IsDeleted?: boolean;
  From?: number;
  Size?: number;
}
